Vue.component('ack-get-quote', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-get-quote',
	mixins: [languageMixins],
	created() {},
	mounted() {},
	props: {},
	computed: {
		isMobile() {
			return this.$parent.isMobile;
		},
	},
	data() {
		return {
			pageId: 'get-quote-page',
		};
	},
	methods: {},
	beforeDestroy() {},
	watch: {
		data1: {
			handler() {},
			deep: false,
		},
	},
});
